import React from 'react';
import { OffersDataService } from '../../../../services/offers-data.service';

export const BannerCta = ({ className, onClick }) => {
    const { buttonText, mainBannerLayout } = OffersDataService.getOffersData();

    return (
        <button
            className={`${className} ${mainBannerLayout}`}
            onClick={onClick}
        >
            {buttonText}
        </button>
    );
};
